// Shared typography helpers for legal pages.
// Defined at module scope (not inside a component) to satisfy
// react/no-unstable-nested-components.

export const LegalH2 = ({ children, id }) => (
  <h2
    id={id}
    className="text-lg sm:text-xl font-bold text-[#311b52] mt-12 mb-4 scroll-mt-28"
    style={{ fontFamily: 'Poppins, sans-serif', letterSpacing: '-0.01em' }}
  >
    {children}
  </h2>
);

export const LegalH3 = ({ children }) => (
  <h3
    className="text-sm font-semibold text-[#311b52] mt-6 mb-2"
    style={{ fontFamily: 'Poppins, sans-serif' }}
  >
    {children}
  </h3>
);

export const LegalP = ({ children, className = '' }) => (
  <p
    className={`text-[15px] leading-[1.75] text-[#3e195e]/80 mb-4 ${className}`}
    style={{ fontFamily: 'Montserrat, sans-serif' }}
  >
    {children}
  </p>
);

export const LegalUL = ({ children }) => (
  <ul
    className="list-disc pl-6 space-y-2 mb-4 text-[15px] leading-[1.75] text-[#3e195e]/80"
    style={{ fontFamily: 'Montserrat, sans-serif' }}
  >
    {children}
  </ul>
);

export const LegalNote = ({ children }) => (
  <p
    className="text-[14px] leading-[1.7] text-[#673c96] bg-[#f37721]/[0.05] border-l-2 border-[#f37721]/40 pl-4 py-3 my-4 italic"
    style={{ fontFamily: 'Montserrat, sans-serif' }}
  >
    {children}
  </p>
);

export const LegalDivider = () => (
  <div className="my-8 flex justify-center">
    <div className="w-12 h-px bg-[#673c96]/20" />
  </div>
);
